import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseSlideshow from 'js/modules/_base/ui/slideshow/BaseSlideshow'

const defaults = {
  instanceName: 'webGLFadeSlideshow',
}

export default class WebGLFadeSlideshow extends BaseSlideshow {
  mesh = []
  constructor(options = {}) {
    super()

    this.callback = {
      next: async () => {
        await new Promise((resolve) => {
          if (this.mesh) {
            gsap.killTweensOf(this.mesh.uniforms.uSlideshowProgress)
            gsap.to(this.mesh.uniforms.uSlideshowProgress, {
              value: 1,
              onComplete: () => {
                if (this.mesh) {
                  this.mesh.currentIndex = (this.mesh.currentIndex + 1) % this.mesh.textures.length
                  this.mesh.uniforms.uCurrentTexture.value = this.mesh.textures[this.mesh.currentIndex]
                  this.mesh.uniforms.uCurrentTextureResolution.value.x = this.mesh.textures[this.mesh.currentIndex].image.naturalWidth
                  this.mesh.uniforms.uCurrentTextureResolution.value.y = this.mesh.textures[this.mesh.currentIndex].image.naturalHeight
                  const nextIndex = (this.mesh.currentIndex + 1) % this.mesh.textures.length
                  this.mesh.uniforms.uNextTexture.value = this.mesh.textures[nextIndex]
                  this.mesh.uniforms.uNextTextureResolution.value.x = this.mesh.textures[nextIndex].image.naturalWidth
                  this.mesh.uniforms.uNextTextureResolution.value.y = this.mesh.textures[nextIndex].image.naturalHeight

                  this.mesh.uniforms.uSlideshowProgress.value = 0
                }
              },
            })
          }

          resolve()
        })
      },
      prev: async () => {
        await new Promise((resolve) => resolve())
      },
      updateIndicator: async () => {
        await new Promise((resolve) => resolve())
      },
    }

    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
  }

  destroy() {
    super.destroy()
    this.mesh = null
  }
}